import { Box } from '@mui/material';
import MuiAppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import { FC } from 'react';

import AccountMenu from './AccountMenu';

interface AppBarProps {
  logo: JSX.Element;
  forExtern?: boolean;
}

export const AppBar: FC<AppBarProps> = ({ logo, forExtern }) => (
  <MuiAppBar
    position="fixed"
    sx={theme => ({
      zIndex: theme.zIndex.drawer + 1,
      background: `linear-gradient(90deg, ${theme.palette.primary.main} 0%, ${theme.palette.secondary.main} 100%)`,
    })}
  >
    <Toolbar>
      <Box
        sx={{
          mr: 'auto',
        }}
      >
        {logo}
      </Box>
      <p style={{ fontFamily: 'Cinzel', fontSize: 20 }}>EffortLog</p>
      <AccountMenu extern={forExtern} />
    </Toolbar>
  </MuiAppBar>
);
